@file:OptIn(InternalLibresApi::class)

package app.spliddy.web.strings

import io.github.skeptick.libres.InternalLibresApi
import io.github.skeptick.libres.LibresLocale
import io.github.skeptick.libres.LibresLocalizations
import kotlin.OptIn
import kotlin.String
import kotlin.collections.firstNotNullOfOrNull

internal object ResStrings {
  private val _baseLocale: StringsEn = StringsEn

  private val _localizations: LibresLocalizations<Strings> = LibresLocalizations(
      LibresLocale(language = "de", script = null, region = null) to StringsDe,
      LibresLocale(language = "en", script = null, region = null) to StringsEn
      )

  public val app_catch_phrase: String
    get() = _localizations.current?.firstNotNullOfOrNull { it.app_catch_phrase } ?: _baseLocale.app_catch_phrase

  public val app_is_under_construction: String
    get() = _localizations.current?.firstNotNullOfOrNull { it.app_is_under_construction } ?: _baseLocale.app_is_under_construction

  public val app_imprint: String
    get() = _localizations.current?.firstNotNullOfOrNull { it.app_imprint } ?: _baseLocale.app_imprint

  public val app_privacy_policy: String
    get() = _localizations.current?.firstNotNullOfOrNull { it.app_privacy_policy } ?: _baseLocale.app_privacy_policy

  public val app_download_app: String
    get() = _localizations.current?.firstNotNullOfOrNull { it.app_download_app } ?: _baseLocale.app_download_app

  public val app_name: String
    get() = _localizations.current?.firstNotNullOfOrNull { it.app_name } ?: _baseLocale.app_name

  public val footer_built_with_love: String
    get() = _localizations.current?.firstNotNullOfOrNull { it.footer_built_with_love } ?: _baseLocale.footer_built_with_love
}
